export const RESERVATION_AGREEMENT = 'reservation_agreement'
export const CONTRACT_FOR_A_FUTURE_PURCHASE_AGREEMENT =
  'contract_for_a_future_purchase_agreement'
export const PURCHASE_AGREEMENT = 'purchase_agreement'
export const CONSTRUCTION_CONTRACT_AGREEMENT = 'construction_contract_agreement'
export const OTHER = 'other'
export const POWER_OF_ATTORNEY = 'power_of_attorney'
export const CLIENT_CHANGE_AGREEMENT = 'client_change_agreement'
export const AMENDMENT = 'amendment'

export const CUSTOM_DOCUMENTATION_CONTRACT_TYPES = [
  CONSTRUCTION_CONTRACT_AGREEMENT,
  OTHER,
  POWER_OF_ATTORNEY,
  CLIENT_CHANGE_AGREEMENT,
  AMENDMENT,
] as const

export type CustomDocumentationContractType =
  (typeof CUSTOM_DOCUMENTATION_CONTRACT_TYPES)[number]

export const ALL_DOCUMENTATION_CONTRACT_TYPES = [
  RESERVATION_AGREEMENT,
  CONTRACT_FOR_A_FUTURE_PURCHASE_AGREEMENT,
  PURCHASE_AGREEMENT,
  ...CUSTOM_DOCUMENTATION_CONTRACT_TYPES,
] as const

export type DocumentationContractType =
  (typeof ALL_DOCUMENTATION_CONTRACT_TYPES)[number]
